export default "__VITE_ASSET__tG1yCouq__"